import React, { useState, useContext,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {LoginContext} from "../contexts/logincontext";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  return date.toLocaleDateString('en-US', options).replace(/(\d+)(st|nd|rd|th)/, '$1');
};

const CustomerMyPlan = () => {
  // States to hold the start and end dates
  const [startDate, setStartDate] = useState('2024-01-21'); // Example initial date
  const [endDate, setEndDate] = useState('2024-07-21'); // Example initial date

  const navigate = useNavigate();

  const {loggedInUser} = useContext(LoginContext);

  useEffect(() => {
    console.log(loggedInUser);
  },[]);
  return (
    <div className="min-h-screen bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-8">My Plan</h2>

        {/* Start Date Card */}
        <div className="mb-4">
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
            <label className="block text-2xl mb-2">Start Date</label>
            <p className="text-lg font-bold">{formatDate(loggedInUser?.start)} </p>
          </div>
        </div>

        {/* End Date Card */}
        <div className="mb-4">
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
            <label className="block text-2xl mb-2">End Date</label>
            <p className="text-lg font-bold">{formatDate(loggedInUser?.end)}</p>
          </div>
        </div>

        {/* Know More Plans Button */}
        <div className="text-center" onClick={() => navigate('/plans')}>
          <button className="py-2 px-2 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-300">
            Know More Plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerMyPlan;
